import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./DailySummary.module.scss";

import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   VerticalLabel                       from '../../../widget/dataDisplay/labels/VerticalLabel';

import { getHeartBeatCount                }  from '../../../../backendServices/customerFrontEventManagment/api';
import { getUserStatusChange              }  from '../../../../backendServices/userManagment/api';
import { getTurnoverAndPaymentCountByDate }  from '../../../../backendServices/paymentManagment/api';
		 

const DailySummary: React.FC = () => {

  const now = new Date();

  const currentDayStart    = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const currentDayEnd      = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  const [ showWaitingIcon        , setShowWaitingIcon        ] = useState(false);

  const [ dailyAudience          , setDailyAudience          ] = useState (0)
  const [ dailyOrderCount        , setDailyOrderCount        ] = useState (0)
  const [ dailySubscriptionCount , setDailySubscriptionCount ] = useState (0)

  const intervalRef    = useRef<NodeJS.Timeout | null>(null);

  const fetchData = async () => {
	  
    try 
     {
      setShowWaitingIcon(true);

      const [ getHeartBeatCountResult                  ,
              getUserStatusChange_all_today_response   ,
              getTurnoverAndPaymentCountByDateResponse ] = await Promise.all([ getHeartBeatCount()                                                    ,
                                                                               getUserStatusChange('All', currentDayStart, currentDayEnd, 'Creation') ,
                                                                               getTurnoverAndPaymentCountByDate(new Date())                           ]);

      const heartBeatCount    = getHeartBeatCountResult.code                  === 1 ? getHeartBeatCountResult.payload.ipCount                       : 0;
      const subscriptionCount = getUserStatusChange_all_today_response.code   === 1 ? getUserStatusChange_all_today_response.payload                : 0;
      const paymentCount      = getTurnoverAndPaymentCountByDateResponse.code === 1 ? getTurnoverAndPaymentCountByDateResponse.payload.paymentCount : 0;

      setDailyAudience(heartBeatCount);
      setDailySubscriptionCount(subscriptionCount);
      setDailyOrderCount(paymentCount);
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
	 
    setShowWaitingIcon(false);
  };

  useEffect(() => {

    fetchData(); 

    intervalRef.current = setInterval(fetchData, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, []);

  const renderDailySummary = () : JSX.Element => {

    return <>

         <VerticalLabel label      = {<>Audiences<br/>du jour</>}
                        value      = {dailyAudience.toString()}
                        width      = "30%"
                        sizeLabel  = {15}
                        sizeValue  = {24}
                        colorValue = "var(--color-Text-FG-emphasized)" />
         <VerticalLabel label      = {<>Commandes<br/>du jour</>}
                        value      = {dailyOrderCount.toString()}
                        width      = "30%"
                        sizeLabel  = {15}
                        sizeValue  = {24}
                        colorValue = "var(--color-Text-FG-emphasized)" />
         <VerticalLabel label      = {<>Abonnements<br/>du jour</>}
                        value      = {dailySubscriptionCount.toString()}
                        width      = "30%"
                        sizeLabel  = {15}
                        sizeValue  = {24}
                        colorValue = "var(--color-Text-FG-emphasized)" />

    </>
  }

  return (
    
      <div className={classNames(styles.root)}>

        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon && <AnimatedWaitingIcon />}
        </div>
	  
        {renderDailySummary()}
		
      </div>

  );
};

export default DailySummary;
